// Lay a poem elegantly over an uploaded photo (client-side canvas) and return a JPEG Blob.
function wrap(ctx, text, maxWidth) {
  const out = [];
  text.split("\n").forEach((para) => {
    if (para.trim() === "") { out.push(""); return; }
    const words = para.split(/\s+/);
    let line = "";
    words.forEach((w) => {
      const test = line ? `${line} ${w}` : w;
      if (ctx.measureText(test).width > maxWidth && line) { out.push(line); line = w; }
      else { line = test; }
    });
    if (line) out.push(line);
  });
  return out;
}

export function composePoemImage(file, { poem, author = "" }) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      // cap the longest edge to keep files reasonable
      const maxEdge = 1600;
      let w = img.naturalWidth, h = img.naturalHeight;
      const scale = Math.min(1, maxEdge / Math.max(w, h));
      w = Math.round(w * scale); h = Math.round(h * scale);

      const canvas = document.createElement("canvas");
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);

      // darkening scrim for legibility (stronger toward the bottom where text sits)
      const scrim = ctx.createLinearGradient(0, 0, 0, h);
      scrim.addColorStop(0, "rgba(10,7,5,0.15)");
      scrim.addColorStop(0.45, "rgba(10,7,5,0.05)");
      scrim.addColorStop(1, "rgba(10,7,5,0.62)");
      ctx.fillStyle = scrim;
      ctx.fillRect(0, 0, w, h);

      const maxWidth = w * 0.84;
      const fontSize = Math.max(22, Math.round(w * (poem.length > 160 ? 0.036 : 0.052)));
      ctx.font = `italic ${fontSize}px Georgia, 'Times New Roman', serif`;
      ctx.textAlign = "center";
      ctx.shadowColor = "rgba(0,0,0,0.55)";
      ctx.shadowBlur = 14;

      const lines = wrap(ctx, poem, maxWidth);
      const lineHeight = fontSize * 1.4;
      const authorGap = author ? fontSize * 1.7 : 0;
      const block = lines.length * lineHeight + authorGap;
      let y = h - h * 0.10 - block + lineHeight; // seat the block near the lower third

      ctx.fillStyle = "#FBF6EC";
      lines.forEach((ln) => { ctx.fillText(ln, w / 2, y); y += lineHeight; });

      if (author) {
        ctx.font = `${Math.round(fontSize * 0.62)}px Georgia, serif`;
        ctx.fillStyle = "#F0D98C";
        ctx.fillText(`— ${author}`, w / 2, y + fontSize * 0.5);
      }
      ctx.shadowBlur = 0;

      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error("compose failed"))),
        "image/jpeg",
        0.9
      );
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("image load failed")); };
    img.src = url;
  });
}
